// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* —— Coin picker (reference: blue field + 5 mint/grey chips) —— */

.deposit-coin-pick {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

/* Search / selected row — blue border, rounded */
.deposit-coin-search-trigger {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 48px;
  padding: 8px 12px 8px 12px;
  border: 1px solid #ababab;
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
  font: inherit;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.deposit-coin-search-trigger:hover {
  border-color: #ababab;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.deposit-coin-search-trigger:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
}

.deposit-trigger-has-error {
  border-color: #dc2626 !important;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.12);
}

.deposit-coin-search-trigger__text {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
  flex-wrap: wrap;
}

.deposit-coin-search-trigger__sym {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: 0.02em;
}

.deposit-coin-search-trigger__full {
  font-size: 15px;
  font-weight: 400;
  color: #94a3b8;
}

.deposit-coin-search-trigger__caret {
  flex: 0 0 auto;
  font-size: 20px;
  color: #94a3b8;
  line-height: 1;
  margin-left: 4px;
}

/* 5 quick chips under field */
.deposit-coin-strip {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 8px 10px;
  width: 100%;
  margin-top: 12px;
  padding-top: 0;
  border-top: none;
  box-sizing: border-box;
  overflow: visible;
}

.deposit-coin-chip {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  flex: 0 0 auto;
  padding: 4px 12px 4px 5px;
  border-radius: 999px;
  border: 1px solid transparent;
  background: #F5F6F7;
  color: #0f172a;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  margin: 0;
  font-family: Inter, system-ui, -apple-system, sans-serif;
  box-sizing: border-box;
}

.deposit-coin-chip:hover {
  background: #e2e8f0;
  border-color: #cbd5e1;
}

/* Selected = mint + green text (reference) */
.deposit-coin-chip.is-selected {
  background: #ecfdf5;
  border: 1px solid #6ee7b7;
  color: #047857;
  box-shadow: none;
}

.deposit-coin-chip.is-selected .deposit-coin-chip__name {
  color: #047857;
}

.deposit-coin-chip.is-selected .deposit-coin-chip__img {
  background: #d1fae5;
}

.deposit-coin-chip.is-selected .deposit-coin-chip__placeholder {
  background: linear-gradient(140deg, #34d399, #059669);
  color: #fff;
  font-weight: 800;
}

.deposit-coin-chip__img {
  width: 20px;
  height: 20px;
  object-fit: cover;
  border-radius: 50px;
  display: block;
}

.deposit-coin-chip__placeholder {
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.02em;
  background: linear-gradient(140deg, #94a3b8, #64748b);
  color: #f8fafc;
  flex-shrink: 0;
  line-height: 1;
}

.deposit-coin-chip__name {
  white-space: nowrap;
  color: inherit;
}

/* —— Stepper: vertical process rail (keep existing UI) —— */
.deposit_crypto_left {
  position: relative;
}

.deposit-stepper-rail {
  position: absolute;
  left: 14px;
  top: var(--rail-top, 0px);
  height: var(--rail-height, 0px);
  width: 2px;
  background: rgba(148, 163, 184, 0.28);
  border-radius: 999px;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.deposit-stepper-rail__fill {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: var(--rail-fill, 0px);
  background: #dadada;
  border-radius: 999px;
  transition: height 220ms ease;
}

body.light_theme .deposit-stepper-rail__fill {
  background: #0b0b0b;
}

/* Coin list (modal) icon */
.deposit-coin-list__img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  background: #e2e8f0;
}

.deposit-coin-list__placeholder {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.02em;
  background: linear-gradient(140deg, #94a3b8, #64748b);
  color: #f8fafc;
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
}

body:not(.light_theme) .deposit-coin-list__img {
  background: #334155;
}

/* Dark dashboard (no light_theme): readable contrast */
body:not(.light_theme) .deposit-coin-search-trigger {
  background: #1a1d24;
  border-color: #3b82f6;
}

body:not(.light_theme) .deposit-coin-search-trigger__sym {
  color: #f1f5f9;
}

body:not(.light_theme) .deposit-coin-search-trigger__full {
  color: #94a3b8;
}

body:not(.light_theme) .deposit-coin-chip {
  background: #2a2d35;
  color: #f1f5f9;
  border-color: rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .deposit-coin-chip:hover {
  background: #333742;
  border-color: rgba(255, 255, 255, 0.12);
}

body:not(.light_theme) .deposit-coin-chip.is-selected {
  background: #064e3b;
  border-color: #34d399;
  color: #a7f3d0;
}

body:not(.light_theme) .deposit-coin-chip.is-selected .deposit-coin-chip__name,
body:not(.light_theme) .deposit-coin-chip.is-selected {
  color: #a7f3d0;
}

body:not(.light_theme) .deposit-coin-chip__img {
  background: #334155;
}

/* Light theme = same as default reference */
body.light_theme .deposit-coin-search-trigger {
  background: #fff;
  border-color: #ababab;
}

@media (max-width: 576px) {
  .deposit-coin-search-trigger {
    min-height: 44px;
    padding: 6px 10px;
    border-radius: 10px;
  }

  .deposit-coin-search-trigger__sym {
    font-size: 15px;
  }

  .deposit-coin-search-trigger__full {
    font-size: 14px;
  }

  .deposit-coin-strip {
    gap: 6px 8px;
    margin-top: 10px;
  }

  .deposit-coin-chip {
    font-size: 12px;
    padding: 3px 10px 3px 4px;
  }
}

/* Deposit history rows — same grid as \`.deposit_history_head\` in public/css-new/style.css */
.depositcrypto_lft .deposit_history_table_wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  min-width: 0;
}

.depositcrypto_lft .deposit_history_body_wrap {
  min-width: 0;
  background: none;
}

.depositcrypto_lft .deposit_history_head_wrap {
  /* scroll handled by \`.deposit_history_table_wrap\` */
  overflow: visible;
}

.depositcrypto_lft .deposit_history_head {
  display: grid;
  /* Must match \`.deposit_history_row\` */
  /* 7 columns: Date, Network, Amount, Deposit Wallet, Address, TxID, Action */
  grid-template-columns: 1.05fr 1.25fr 0.9fr 0.95fr 1.55fr 1.55fr 0.75fr;
  gap: 8px;
  align-items: center;
}

.depositcrypto_lft .deposit_history_head,
.depositcrypto_lft .deposit_history_row {
  /* Keep header + body aligned for horizontal scroll */
  min-width: 1240px;
}

.depositcrypto_lft .deposit_history_head_cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.depositcrypto_lft .deposit_history_row {
  display: grid;
  /* 7 columns: Date, Network, Amount, Deposit Wallet, Address, TxID, Action */
  grid-template-columns: 1.05fr 1.25fr 0.9fr 0.95fr 1.55fr 1.55fr 0.75fr;
  gap: 8px;
  padding: 12px 0;
  border-top: 1px solid #545454;
  font-size: 13px;
  font-weight: 500;
  color: #cecece;
  line-height: 1.3;
  align-items: start;
  box-sizing: border-box;
}

body.light_theme .depositcrypto_lft .deposit_history_row {
  color: #101828;
}

.depositcrypto_lft .deposit_history_row_cell {
  /* Keep one-line rows; table scrolls horizontally */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.depositcrypto_lft .deposit_history_row_cell--action {
  text-transform: capitalize;
}

.depositcrypto_lft .deposit_history_trunc {
  display: inline-block;
  vertical-align: middle;
  max-width: calc(100% - 72px);
}

.depositcrypto_lft .deposit_history_copy_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: #f8fafc;
  color: #334155;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.05s ease;
  padding: 0;
  line-height: 1;
}

.depositcrypto_lft .deposit_history_copy_btn:hover {
  background: #eef2ff;
  border-color: rgba(99, 102, 241, 0.55);
  color: #3730a3;
}

.depositcrypto_lft .deposit_history_copy_btn:active {
  transform: translateY(0.5px);
}

.depositcrypto_lft .deposit_history_copy_btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
}

.depositcrypto_lft .deposit_history_copy_btn.deposit_history_explorer_link {
  text-decoration: none;
}

.depositcrypto_lft .deposit_history_action_badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid transparent;
  white-space: nowrap;
  line-height: 1;
}

/* Action “button” colors */
.depositcrypto_lft .deposit_history_action_badge.is-success {
  background: #ecfdf31a;
  border-color: #a7f3d024;
  color: #0c935a;
}

body.light_theme .depositcrypto_lft .deposit_history_action_badge.is-success {
  background: #ecfdf3;
  border-color: #a7f3d0;
}

.depositcrypto_lft .deposit_history_action_badge.is-pending {
  background: #fffbeb17;
  border-color: #fde68a1a;
  color: #cd7641;
  word-break: normal;
  white-space: normal;
  text-align: center;
}


body.light_theme .depositcrypto_lft .deposit_history_action_badge.is-pending {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
}


.depositcrypto_lft .deposit_history_action_badge.is-danger {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b42318;
}

.depositcrypto_lft .deposit_history_action_badge.is-info {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.depositcrypto_lft .deposit_history_action_badge.is-neutral {
  background: #f1f5f9;
  border-color: #e2e8f0;
  color: #334155;
}

/* Dark dashboard support */
body:not(.light_theme) .depositcrypto_lft .deposit_history_copy_btn {
  background: #1f2937;
  border-color: rgba(148, 163, 184, 0.35);
  color: #e2e8f0;
}

body:not(.light_theme) .depositcrypto_lft .deposit_history_copy_btn:hover {
  background: rgba(59, 130, 246, 0.18);
  border-color: rgba(59, 130, 246, 0.45);
  color: #bfdbfe;
}

body:not(.light_theme) .depositcrypto_lft .deposit_history_action_badge.is-neutral {
  background: rgba(148, 163, 184, 0.12);
  border-color: rgba(148, 163, 184, 0.22);
  color: #e2e8f0;
}

/* Deposit details — Figma: QR left, address + memo + three meta lines */
.depositcrypto_lft .deposit_qr_box_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 190px;
  margin: 0 auto;
}

.depositcrypto_lft .deposit_meta_label {
  white-space: nowrap;
}

.depositcrypto_lft .deposit_meta_label::after {
  content: ":";
}

.depositcrypto_lft .deposit_meta_value--strong {
  font-weight: 700;
  color: #f1f1f1;
}

body.light_theme .depositcrypto_lft .deposit_meta_value--strong {
  color: #101828;
}

.depositcrypto_lft .deposit_field_input input.deposit_memo_input--empty {
  color: #98a2b3;
}

/* Fireblocks + CryptoSwift architecture (collapsible) */
.deposit-fb-doc {
  margin-top: 28px;
  width: 100%;
  max-width: 100%;
}

.deposit-fb-doc__details {
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  background: #f8fafc;
  overflow: hidden;
}

.deposit-fb-doc__summary {
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  padding: 14px 16px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 600;
  color: #0f172a;
}

.deposit-fb-doc__summary::-webkit-details-marker {
  display: none;
}

.deposit-fb-doc__summary::after {
  content: "";
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #64748b;
  margin-left: auto;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.deposit-fb-doc__details[open] .deposit-fb-doc__summary::after {
  transform: rotate(180deg);
}

.deposit-fb-doc__summary-icon {
  display: flex;
  color: #3b82f6;
  flex-shrink: 0;
}

.deposit-fb-doc__summary-title {
  font-size: 1rem;
}

.deposit-fb-doc__summary-sub {
  font-size: 0.8rem;
  font-weight: 500;
  color: #64748b;
  width: 100%;
  padding-left: 28px;
  margin-top: -4px;
}

@media (min-width: 640px) {
  .deposit-fb-doc__summary-sub {
    width: auto;
    margin-top: 0;
    padding-left: 0;
  }
}

.deposit-fb-doc__body {
  padding: 0 16px 18px 16px;
  border-top: 1px solid #e4e7ec;
  background: #fff;
}

.deposit-fb-doc__intro {
  font-size: 0.9rem;
  line-height: 1.5;
  color: #334155;
  margin: 14px 0 12px 0;
}

.deposit-fb-doc__h3 {
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
  margin: 1.1rem 0 0.5rem 0;
}

.deposit-fb-doc__h3:first-of-type {
  margin-top: 0.5rem;
}

.deposit-fb-doc__p,
.deposit-fb-doc__ul {
  font-size: 0.875rem;
  line-height: 1.55;
  color: #475569;
  margin: 0 0 0.5rem 0;
}

.deposit-fb-doc__ul {
  padding-left: 1.2rem;
}

.deposit-fb-doc__ul li {
  margin-bottom: 0.35rem;
}

.deposit-fb-doc__flow {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 0.5rem 0 1rem 0;
}

.deposit-fb-doc__flow-col {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
}

.deposit-fb-doc__flow-kicker {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin: 0 0 6px 0;
  font-weight: 700;
}

.deposit-fb-doc__flow-steps {
  margin: 0;
  padding-left: 1.1rem;
  font-size: 0.8rem;
  line-height: 1.5;
  color: #334155;
}

.deposit-fb-doc__flow-steps li {
  margin-bottom: 0.25rem;
}

.deposit-fb-doc__flow-note {
  font-size: 0.8rem;
  line-height: 1.5;
  color: #334155;
  margin: 0;
}

.deposit-fb-doc__flow-arrow {
  text-align: center;
  color: #94a3b8;
  font-size: 0.9rem;
  line-height: 1.2;
  padding: 4px 0;
}

.deposit-fb-doc__table-wrap {
  margin: 0.4rem 0 0.75rem 0;
  font-size: 0.8rem;
}

.deposit-fb-doc__table th {
  background: #f8fafc;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
  max-width: 180px;
}

.deposit-fb-doc__table td {
  color: #475569;
  vertical-align: top;
}

/* Deposit history: desktop grid vs mobile cards (matches withdraw “Recent” pattern) */
.depositcrypto_lft .deposit_history_mobile {
  display: none;
}

.deposit_hist_mobile_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}

.deposit_hist_mobile_date {
  font-size: 13px;
  font-weight: 600;
  color: #eaecef;
}

body.light_theme .deposit_hist_mobile_date {
  color: #101828;
}

.deposit_hist_mobile_row--actions .value {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 72%;
  text-align: right;
}

@media (max-width: 991.98px) {
  .depositcrypto_lft .deposit_history_desktop {
    display: none !important;
  }

  .depositcrypto_lft .deposit_history_mobile {
    display: block !important;
  }

  .depositcrypto_lft .deposit_history_table_wrap {
    overflow-x: visible;
  }
}

/* —— Loading: deposit options (coin row + quick chips, network row) —— */
@keyframes deposit-skeleton-shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

.deposit-options-skeleton {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.deposit-options-skeleton--network {
  margin-top: 0;
}

.deposit-options-skeleton__bone {
  display: block;
  background: linear-gradient(90deg, #2a2e36 0%, #3a3f4a 45%, #2a2e36 90%);
  background-size: 200% 100%;
  animation: deposit-skeleton-shimmer 1.35s ease-in-out infinite;
}

body.light_theme .deposit-options-skeleton__bone {
  background: linear-gradient(90deg, #e8eaed 0%, #f1f5f9 45%, #e8eaed 90%);
  background-size: 200% 100%;
  animation: deposit-skeleton-shimmer 1.35s ease-in-out infinite;
}

.deposit-options-skeleton__trigger {
  width: 100%;
  min-height: 48px;
  border-radius: 12px;
}

.deposit-options-skeleton__chips {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
}

.deposit-options-skeleton__chip {
  width: 72px;
  height: 28px;
  border-radius: 999px;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/DepositPage/depositPage.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,WAAW;AACb;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,SAAS;EACT,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,qDAAqD;EACrD,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,+BAA+B;EAC/B,UAAU;EACV,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qDAAqD;EACrD,cAAc;EACd,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA,4FAA4F;AAC5F;EACE,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,4EAA4E;EAC5E,sEAAsE;EACtE,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,qDAAqD;EACrD,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,4EAA4E;EAC5E,sEAAsE;EACtE,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kGAAkG;EAClG,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;;AAGA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,sFAAsF;AACtF;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,yEAAyE;AACzE;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,wEAAwE;EACxE,0BAA0B;EAC1B,8DAA8D;AAChE;;AAEA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,8DAA8D;AAChE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":["/* —— Coin picker (reference: blue field + 5 mint/grey chips) —— */\n\n.deposit-coin-pick {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 100%;\n}\n\n/* Search / selected row — blue border, rounded */\n.deposit-coin-search-trigger {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-height: 48px;\n  padding: 8px 12px 8px 12px;\n  border: 1px solid #ababab;\n  border-radius: 12px;\n  background: #ffffff;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.deposit-coin-search-trigger:hover {\n  border-color: #ababab;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\n}\n\n.deposit-coin-search-trigger:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);\n}\n\n.deposit-trigger-has-error {\n  border-color: #dc2626 !important;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.12);\n}\n\n.deposit-coin-search-trigger__text {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.deposit-coin-search-trigger__sym {\n  font-size: 16px;\n  font-weight: 600;\n  color: #0f172a;\n  letter-spacing: 0.02em;\n}\n\n.deposit-coin-search-trigger__full {\n  font-size: 15px;\n  font-weight: 400;\n  color: #94a3b8;\n}\n\n.deposit-coin-search-trigger__caret {\n  flex: 0 0 auto;\n  font-size: 20px;\n  color: #94a3b8;\n  line-height: 1;\n  margin-left: 4px;\n}\n\n/* 5 quick chips under field */\n.deposit-coin-strip {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px 10px;\n  width: 100%;\n  margin-top: 12px;\n  padding-top: 0;\n  border-top: none;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.deposit-coin-chip {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n  flex: 0 0 auto;\n  padding: 4px 12px 4px 5px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  background: #F5F6F7;\n  color: #0f172a;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n  margin: 0;\n  font-family: Inter, system-ui, -apple-system, sans-serif;\n  box-sizing: border-box;\n}\n\n.deposit-coin-chip:hover {\n  background: #e2e8f0;\n  border-color: #cbd5e1;\n}\n\n/* Selected = mint + green text (reference) */\n.deposit-coin-chip.is-selected {\n  background: #ecfdf5;\n  border: 1px solid #6ee7b7;\n  color: #047857;\n  box-shadow: none;\n}\n\n.deposit-coin-chip.is-selected .deposit-coin-chip__name {\n  color: #047857;\n}\n\n.deposit-coin-chip.is-selected .deposit-coin-chip__img {\n  background: #d1fae5;\n}\n\n.deposit-coin-chip.is-selected .deposit-coin-chip__placeholder {\n  background: linear-gradient(140deg, #34d399, #059669);\n  color: #fff;\n  font-weight: 800;\n}\n\n.deposit-coin-chip__img {\n  width: 20px;\n  height: 20px;\n  object-fit: cover;\n  border-radius: 50px;\n  display: block;\n}\n\n.deposit-coin-chip__placeholder {\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  background: linear-gradient(140deg, #94a3b8, #64748b);\n  color: #f8fafc;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.deposit-coin-chip__name {\n  white-space: nowrap;\n  color: inherit;\n}\n\n/* —— Stepper: vertical process rail (keep existing UI) —— */\n.deposit_crypto_left {\n  position: relative;\n}\n\n.deposit-stepper-rail {\n  position: absolute;\n  left: 14px;\n  top: var(--rail-top, 0px);\n  height: var(--rail-height, 0px);\n  width: 2px;\n  background: rgba(148, 163, 184, 0.28);\n  border-radius: 999px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.deposit-stepper-rail__fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: var(--rail-fill, 0px);\n  background: #dadada;\n  border-radius: 999px;\n  transition: height 220ms ease;\n}\n\nbody.light_theme .deposit-stepper-rail__fill {\n  background: #0b0b0b;\n}\n\n/* Coin list (modal) icon */\n.deposit-coin-list__img {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  object-fit: cover;\n  display: block;\n  background: #e2e8f0;\n}\n\n.deposit-coin-list__placeholder {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  background: linear-gradient(140deg, #94a3b8, #64748b);\n  color: #f8fafc;\n  line-height: 1;\n  user-select: none;\n}\n\nbody:not(.light_theme) .deposit-coin-list__img {\n  background: #334155;\n}\n\n/* Dark dashboard (no light_theme): readable contrast */\nbody:not(.light_theme) .deposit-coin-search-trigger {\n  background: #1a1d24;\n  border-color: #3b82f6;\n}\n\nbody:not(.light_theme) .deposit-coin-search-trigger__sym {\n  color: #f1f5f9;\n}\n\nbody:not(.light_theme) .deposit-coin-search-trigger__full {\n  color: #94a3b8;\n}\n\nbody:not(.light_theme) .deposit-coin-chip {\n  background: #2a2d35;\n  color: #f1f5f9;\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .deposit-coin-chip:hover {\n  background: #333742;\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\nbody:not(.light_theme) .deposit-coin-chip.is-selected {\n  background: #064e3b;\n  border-color: #34d399;\n  color: #a7f3d0;\n}\n\nbody:not(.light_theme) .deposit-coin-chip.is-selected .deposit-coin-chip__name,\nbody:not(.light_theme) .deposit-coin-chip.is-selected {\n  color: #a7f3d0;\n}\n\nbody:not(.light_theme) .deposit-coin-chip__img {\n  background: #334155;\n}\n\n/* Light theme = same as default reference */\nbody.light_theme .deposit-coin-search-trigger {\n  background: #fff;\n  border-color: #ababab;\n}\n\n@media (max-width: 576px) {\n  .deposit-coin-search-trigger {\n    min-height: 44px;\n    padding: 6px 10px;\n    border-radius: 10px;\n  }\n\n  .deposit-coin-search-trigger__sym {\n    font-size: 15px;\n  }\n\n  .deposit-coin-search-trigger__full {\n    font-size: 14px;\n  }\n\n  .deposit-coin-strip {\n    gap: 6px 8px;\n    margin-top: 10px;\n  }\n\n  .deposit-coin-chip {\n    font-size: 12px;\n    padding: 3px 10px 3px 4px;\n  }\n}\n\n/* Deposit history rows — same grid as `.deposit_history_head` in public/css-new/style.css */\n.depositcrypto_lft .deposit_history_table_wrap {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  min-width: 0;\n}\n\n.depositcrypto_lft .deposit_history_body_wrap {\n  min-width: 0;\n  background: none;\n}\n\n.depositcrypto_lft .deposit_history_head_wrap {\n  /* scroll handled by `.deposit_history_table_wrap` */\n  overflow: visible;\n}\n\n.depositcrypto_lft .deposit_history_head {\n  display: grid;\n  /* Must match `.deposit_history_row` */\n  /* 7 columns: Date, Network, Amount, Deposit Wallet, Address, TxID, Action */\n  grid-template-columns: 1.05fr 1.25fr 0.9fr 0.95fr 1.55fr 1.55fr 0.75fr;\n  gap: 8px;\n  align-items: center;\n}\n\n.depositcrypto_lft .deposit_history_head,\n.depositcrypto_lft .deposit_history_row {\n  /* Keep header + body aligned for horizontal scroll */\n  min-width: 1240px;\n}\n\n.depositcrypto_lft .deposit_history_head_cell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.depositcrypto_lft .deposit_history_row {\n  display: grid;\n  /* 7 columns: Date, Network, Amount, Deposit Wallet, Address, TxID, Action */\n  grid-template-columns: 1.05fr 1.25fr 0.9fr 0.95fr 1.55fr 1.55fr 0.75fr;\n  gap: 8px;\n  padding: 12px 0;\n  border-top: 1px solid #545454;\n  font-size: 13px;\n  font-weight: 500;\n  color: #cecece;\n  line-height: 1.3;\n  align-items: start;\n  box-sizing: border-box;\n}\n\nbody.light_theme .depositcrypto_lft .deposit_history_row {\n  color: #101828;\n}\n\n.depositcrypto_lft .deposit_history_row_cell {\n  /* Keep one-line rows; table scrolls horizontally */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.depositcrypto_lft .deposit_history_row_cell--action {\n  text-transform: capitalize;\n}\n\n.depositcrypto_lft .deposit_history_trunc {\n  display: inline-block;\n  vertical-align: middle;\n  max-width: calc(100% - 72px);\n}\n\n.depositcrypto_lft .deposit_history_copy_btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  background: #f8fafc;\n  color: #334155;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.05s ease;\n  padding: 0;\n  line-height: 1;\n}\n\n.depositcrypto_lft .deposit_history_copy_btn:hover {\n  background: #eef2ff;\n  border-color: rgba(99, 102, 241, 0.55);\n  color: #3730a3;\n}\n\n.depositcrypto_lft .deposit_history_copy_btn:active {\n  transform: translateY(0.5px);\n}\n\n.depositcrypto_lft .deposit_history_copy_btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);\n}\n\n.depositcrypto_lft .deposit_history_copy_btn.deposit_history_explorer_link {\n  text-decoration: none;\n}\n\n.depositcrypto_lft .deposit_history_action_badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n/* Action “button” colors */\n.depositcrypto_lft .deposit_history_action_badge.is-success {\n  background: #ecfdf31a;\n  border-color: #a7f3d024;\n  color: #0c935a;\n}\n\nbody.light_theme .depositcrypto_lft .deposit_history_action_badge.is-success {\n  background: #ecfdf3;\n  border-color: #a7f3d0;\n}\n\n.depositcrypto_lft .deposit_history_action_badge.is-pending {\n  background: #fffbeb17;\n  border-color: #fde68a1a;\n  color: #cd7641;\n  word-break: normal;\n  white-space: normal;\n  text-align: center;\n}\n\n\nbody.light_theme .depositcrypto_lft .deposit_history_action_badge.is-pending {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #92400e;\n}\n\n\n.depositcrypto_lft .deposit_history_action_badge.is-danger {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b42318;\n}\n\n.depositcrypto_lft .deposit_history_action_badge.is-info {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n}\n\n.depositcrypto_lft .deposit_history_action_badge.is-neutral {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n  color: #334155;\n}\n\n/* Dark dashboard support */\nbody:not(.light_theme) .depositcrypto_lft .deposit_history_copy_btn {\n  background: #1f2937;\n  border-color: rgba(148, 163, 184, 0.35);\n  color: #e2e8f0;\n}\n\nbody:not(.light_theme) .depositcrypto_lft .deposit_history_copy_btn:hover {\n  background: rgba(59, 130, 246, 0.18);\n  border-color: rgba(59, 130, 246, 0.45);\n  color: #bfdbfe;\n}\n\nbody:not(.light_theme) .depositcrypto_lft .deposit_history_action_badge.is-neutral {\n  background: rgba(148, 163, 184, 0.12);\n  border-color: rgba(148, 163, 184, 0.22);\n  color: #e2e8f0;\n}\n\n/* Deposit details — Figma: QR left, address + memo + three meta lines */\n.depositcrypto_lft .deposit_qr_box_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 190px;\n  margin: 0 auto;\n}\n\n.depositcrypto_lft .deposit_meta_label {\n  white-space: nowrap;\n}\n\n.depositcrypto_lft .deposit_meta_label::after {\n  content: \":\";\n}\n\n.depositcrypto_lft .deposit_meta_value--strong {\n  font-weight: 700;\n  color: #f1f1f1;\n}\n\nbody.light_theme .depositcrypto_lft .deposit_meta_value--strong {\n  color: #101828;\n}\n\n.depositcrypto_lft .deposit_field_input input.deposit_memo_input--empty {\n  color: #98a2b3;\n}\n\n/* Fireblocks + CryptoSwift architecture (collapsible) */\n.deposit-fb-doc {\n  margin-top: 28px;\n  width: 100%;\n  max-width: 100%;\n}\n\n.deposit-fb-doc__details {\n  border: 1px solid #e4e7ec;\n  border-radius: 12px;\n  background: #f8fafc;\n  overflow: hidden;\n}\n\n.deposit-fb-doc__summary {\n  list-style: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n  padding: 14px 16px;\n  cursor: pointer;\n  user-select: none;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.deposit-fb-doc__summary::-webkit-details-marker {\n  display: none;\n}\n\n.deposit-fb-doc__summary::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 6px solid #64748b;\n  margin-left: auto;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.deposit-fb-doc__details[open] .deposit-fb-doc__summary::after {\n  transform: rotate(180deg);\n}\n\n.deposit-fb-doc__summary-icon {\n  display: flex;\n  color: #3b82f6;\n  flex-shrink: 0;\n}\n\n.deposit-fb-doc__summary-title {\n  font-size: 1rem;\n}\n\n.deposit-fb-doc__summary-sub {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #64748b;\n  width: 100%;\n  padding-left: 28px;\n  margin-top: -4px;\n}\n\n@media (min-width: 640px) {\n  .deposit-fb-doc__summary-sub {\n    width: auto;\n    margin-top: 0;\n    padding-left: 0;\n  }\n}\n\n.deposit-fb-doc__body {\n  padding: 0 16px 18px 16px;\n  border-top: 1px solid #e4e7ec;\n  background: #fff;\n}\n\n.deposit-fb-doc__intro {\n  font-size: 0.9rem;\n  line-height: 1.5;\n  color: #334155;\n  margin: 14px 0 12px 0;\n}\n\n.deposit-fb-doc__h3 {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 1.1rem 0 0.5rem 0;\n}\n\n.deposit-fb-doc__h3:first-of-type {\n  margin-top: 0.5rem;\n}\n\n.deposit-fb-doc__p,\n.deposit-fb-doc__ul {\n  font-size: 0.875rem;\n  line-height: 1.55;\n  color: #475569;\n  margin: 0 0 0.5rem 0;\n}\n\n.deposit-fb-doc__ul {\n  padding-left: 1.2rem;\n}\n\n.deposit-fb-doc__ul li {\n  margin-bottom: 0.35rem;\n}\n\n.deposit-fb-doc__flow {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin: 0.5rem 0 1rem 0;\n}\n\n.deposit-fb-doc__flow-col {\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px 12px;\n}\n\n.deposit-fb-doc__flow-kicker {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  margin: 0 0 6px 0;\n  font-weight: 700;\n}\n\n.deposit-fb-doc__flow-steps {\n  margin: 0;\n  padding-left: 1.1rem;\n  font-size: 0.8rem;\n  line-height: 1.5;\n  color: #334155;\n}\n\n.deposit-fb-doc__flow-steps li {\n  margin-bottom: 0.25rem;\n}\n\n.deposit-fb-doc__flow-note {\n  font-size: 0.8rem;\n  line-height: 1.5;\n  color: #334155;\n  margin: 0;\n}\n\n.deposit-fb-doc__flow-arrow {\n  text-align: center;\n  color: #94a3b8;\n  font-size: 0.9rem;\n  line-height: 1.2;\n  padding: 4px 0;\n}\n\n.deposit-fb-doc__table-wrap {\n  margin: 0.4rem 0 0.75rem 0;\n  font-size: 0.8rem;\n}\n\n.deposit-fb-doc__table th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #334155;\n  white-space: nowrap;\n  max-width: 180px;\n}\n\n.deposit-fb-doc__table td {\n  color: #475569;\n  vertical-align: top;\n}\n\n/* Deposit history: desktop grid vs mobile cards (matches withdraw “Recent” pattern) */\n.depositcrypto_lft .deposit_history_mobile {\n  display: none;\n}\n\n.deposit_hist_mobile_top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 6px;\n}\n\n.deposit_hist_mobile_date {\n  font-size: 13px;\n  font-weight: 600;\n  color: #eaecef;\n}\n\nbody.light_theme .deposit_hist_mobile_date {\n  color: #101828;\n}\n\n.deposit_hist_mobile_row--actions .value {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 8px;\n  max-width: 72%;\n  text-align: right;\n}\n\n@media (max-width: 991.98px) {\n  .depositcrypto_lft .deposit_history_desktop {\n    display: none !important;\n  }\n\n  .depositcrypto_lft .deposit_history_mobile {\n    display: block !important;\n  }\n\n  .depositcrypto_lft .deposit_history_table_wrap {\n    overflow-x: visible;\n  }\n}\n\n/* —— Loading: deposit options (coin row + quick chips, network row) —— */\n@keyframes deposit-skeleton-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.deposit-options-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.deposit-options-skeleton--network {\n  margin-top: 0;\n}\n\n.deposit-options-skeleton__bone {\n  display: block;\n  background: linear-gradient(90deg, #2a2e36 0%, #3a3f4a 45%, #2a2e36 90%);\n  background-size: 200% 100%;\n  animation: deposit-skeleton-shimmer 1.35s ease-in-out infinite;\n}\n\nbody.light_theme .deposit-options-skeleton__bone {\n  background: linear-gradient(90deg, #e8eaed 0%, #f1f5f9 45%, #e8eaed 90%);\n  background-size: 200% 100%;\n  animation: deposit-skeleton-shimmer 1.35s ease-in-out infinite;\n}\n\n.deposit-options-skeleton__trigger {\n  width: 100%;\n  min-height: 48px;\n  border-radius: 12px;\n}\n\n.deposit-options-skeleton__chips {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 10px;\n}\n\n.deposit-options-skeleton__chip {\n  width: 72px;\n  height: 28px;\n  border-radius: 999px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
